<template>
  <span class="flex items-center gap-1">
    <Favicon v-if="faviconURL" :value="faviconURL" />
    <span class="select-all truncate">{{ mungedValue }}</span>
  </span>
</template>

<script setup lang="ts">
import { computed } from "vue";

import Favicon from "../Utilities/Favicon.vue";

const ANDROID_APP_SCHEME = "android-app://";

const ANDROID_URI_TO_LABEL = {
  "com.google.android.gm": "Gmail",
  "com.linkedin.android": "LinkedIn",
  "com.slack": "Slack",
  "org.joinmastodon.android": "Mastodon",
};

const LABEL_TO_FAVICON_URL = {
  Gmail: "https://www.google.com",
  LinkedIn: "https://www.linkedin.com",
  Slack: "https://www.slack.com",
  Mastodon: "https://www.mastodon.social",
};

const OVERRIDES = {
  "https://gmail.com": "https://mail.google.com",
};

const faviconURL = computed(() => {
  if (props.value.startsWith("http")) {
    if (props.value.endsWith(".slack.com")) {
      return "https://www.slack.com";
    }
    if (props.value in OVERRIDES) {
      return OVERRIDES[props.value as keyof typeof OVERRIDES];
    }
    return props.value;
  }
  if (mungedValue.value in LABEL_TO_FAVICON_URL) {
    return LABEL_TO_FAVICON_URL[
      mungedValue.value as keyof typeof LABEL_TO_FAVICON_URL
    ];
  }
  return null;
});

const mungedValue = computed(() => {
  const normalizedURL = props.value
    .replace("https://", "")
    .replace("http://", "")
    .replace("www.", "");

  if (normalizedURL.startsWith(ANDROID_APP_SCHEME)) {
    const uri = normalizedURL.replace(ANDROID_APP_SCHEME, "");
    if (uri in ANDROID_URI_TO_LABEL) {
      return ANDROID_URI_TO_LABEL[uri as keyof typeof ANDROID_URI_TO_LABEL];
    }
    return normalizedURL;
  }

  return normalizedURL.replace(/\/$/, "");
});

const props = defineProps<{
  value: string;
}>();
</script>
